import socials from '@/config/socials'
import networks from '@/config/networks'
import hooks from '@/config/hooks'

export default defineAppConfig({
  socials,
  networks,
  hooks,
  mockTransfer: false,
})
